module.exports = __webpack_public_path__ + "static/Moonlighter1-6074a7989abb9ee6bf56bbc457368045.png";